
import { Article, IContentTag } from '@common/domain/models/Article';
import { ISetSearchPageLocation } from '@common/redux/content/actions';

import { IState } from '@store/webInterfaces';

// fetch list of articles
export const fetchArticlesLoaderSelector = (state: any, groupName: string): boolean => {
    return state?.content?.loaders[`${groupName}_articles`] || false;
};

export const fetchArticlesErrorSelector = (state: IState, groupName: string): string => {
    return state?.content?.errors[`${groupName}_articles`] || '';
};

export const getContentTypeMapSelector = (state: IState) => {
    return state?.content?.contentTypeMap || {};
}

export const fetchTagsLoaderSelector = (state: IState): boolean => {
    return state?.content?.loaders?.tags || false;
};

export const fetchTagsErrorSelector = (state: IState): string => {
    return state?.content?.errors.tags || '';
};

export const fetchTagsSelector = (state: IState): IContentTag[] => {
    return state?.content?.tags || [];
}

export const fetchCountMapSelector = (state: IState): {} => {
    return state?.content?.count || {};
}
// Fetch Article Details By Id
export const fetchArticlesByIdLoaderSelector = (state: IState): boolean => {
    return state?.content?.loaders?.articleDetails || false;
};

export const fetchArticlesByIdErrorSelector = (state: IState): string => {
    return state?.content?.errors?.articleDetails || "";
};

export const fetchArticleMapByIdSelector = (state: IState): {} => {
    return state?.content?.byId || {};
};

//Like Article
export const likeArticleLoaderSelector = (state:IState):boolean=>{
    return state?.content?.loaders?.like ||false;
}

export const likeArticleErrorSelector = (state:IState):string=>{
    return state?.content?.errors?.like|| ""
}

//UnLike Article
export const unLikeArticleLoaderSelector = (state:IState):boolean=>{
    return state?.content?.loaders?.unLike ||false;
}

export const unLikeArticleErrorSelector = (state:IState):string=>{
    return state?.content?.errors?.unLike|| ""
}

//Fetch Suggested Article
export const getSuggestedArticles = (state:IState):Article[]=>{
    return state?.content?.suggestedArticle || [];
}

export const getSuggestedArticlesLoader = (state:IState):boolean=>{
    return state?.content?.loaders?.suggestedArticle
}

export const getSuggestedArticlesError = (state:IState):string=>{
    return state?.content?.errors?.suggestedArticle
}

export const getTagsMapSelector = (state: IState) => {
    return state?.content?.tagsMap || {};
}

export const getSearchPageLocation = (state:IState):ISetSearchPageLocation=>{
    return state?.content?.searchPageLocation || {} as ISetSearchPageLocation;
};

export const fetchisLastPageSelector = (state: any, groupName: string): boolean => {
    return state?.content?.isLastPage[groupName] || false;
};
